import { edgeTypeMatrix as FW_EdgeTypeMatrix, getParentToChildEdgeTypeMatrixEntry } from '@iotv/datamodel-core'
import { EdgeTypeMatrixType } from './types'

// this needs to conform to EdgeTypeMatrixType but is not typed as such to allow direct access to sub attributes
export const edgeTypeMatrix = {
  // ...FW_EdgeTypeMatrix,
  Customer: {
    ...FW_EdgeTypeMatrix.Customer,
    Irrigator: {
      customerHasIrrigator: {
        cardinality: undefined,
        edgeTypeId: 'customerHasIrrigator',
        labels: {
          in: 'customer has irrigator',
          out: 'irrigator belongs to customer',
        },
        edgeAttributes: {},
      },
    },
    IrrigationZone: {
      customerHasIrrigationZone: {
        cardinality: undefined,
        edgeTypeId: 'customerHasIrrigationZone',
        labels: {
          in: 'customer has irrigation zone',
          out: 'irrigation zone belongs to customer',
        },
        edgeAttributes: {},
      },
    },
    IrrigationPattern: {
      customerHasIrrigationPattern: {
        cardinality: undefined,
        edgeTypeId: 'customerHasIrrigationPattern',
        labels: {
          in: 'customer has irrigation pattern',
          out: 'irrigation pattern belongs to customer',
        },
        edgeAttributes: {},
      },
    },
    SpreadingEvent: {
      customerHasSpreadingEvent: {
        cardinality: undefined,
        edgeTypeId: 'customer_has_spreadingEvent',
        labels: {
          in: 'Customer has spreading event',
          out: 'Spreading event belongs to customer',
        },
        edgeAttributes: {},
      },
    },
    /** Removed as now provided from @iotv/datamodel-core */
    // Property: {
    //   customerHasProperty: {
    //     cardinality: undefined,
    //     edgeTypeId: 'customerHasProperty',
    //     labels: {
    //       in: 'The customer of this property',
    //       out: 'Property belonging to this customer',
    //     },
    //     edgeAttributes: {},
    //   },
    // },

    IrrigatorSequentialProgramme: {
      customerHasIrrigatorSequentialProgramme: {
        cardinality: undefined,
        edgeTypeId: 'customerHasIrrigatorSequentialProgramme',
        labels: {
          in: 'customer has Sequential programme',
          out: 'Sequential programme belongs to customer',
        },
        edgeAttributes: {},
      },
    },
    IrrigatorRollingProgramme: {
      customerHasIrrigatorRollingProgramme: {
        cardinality: undefined,
        edgeTypeId: 'customerHasIrrigatorRollingProgramme',
        labels: {
          in: 'customer has rolling programme',
          out: 'rolling programme belongs to customer',
        },
        edgeAttributes: {},
      },
    },
    Device: FW_EdgeTypeMatrix.Customer.Device,
  },
  Waternetwork: {
    Entity: {
      waternetworkHasEntity: {
        cardinality: undefined,
        edgeTypeId: 'waternetworkHasEntity',
        labels: {
          in: 'waternetwork has Entity',
          out: 'Entity belongs to waternetwork',
        },
        edgeAttributes: {},
      },
    },
  },
  Property: {
    Paddock: {
      propertyHasPaddock: {
        cardinality: undefined,
        edgeTypeId: 'propertyHasPaddock',
        labels: {
          in: 'Property with this paddock',
          out: 'Paddock(s) in this property',
        },
        edgeAttributes: {},
      },
    },
    Waternetwork: {
      propertyHasWaternetwork: {
        cardinality: undefined,
        edgeTypeId: 'propertyHasWaternetwork',
        labels: {
          in: 'property has Waternetwork',
          out: 'Waternetwork belongs to property',
        },
        edgeAttributes: {},
      },
    },
    Waterway: {
      propertyHasWaterways: {
        cardinality: undefined,
        edgeTypeId: 'propertyHasWaterways',
        labels: {
          in: 'Property with this waterway',
          out: 'Waterway(s) in this property',
        },
        edgeAttributes: {},
      },
    },
    IrrigationZone: {
      propertyHasIrrigatationZone: {
        cardinality: undefined,
        edgeTypeId: 'propertyHasIrrigatationZone',
        labels: {
          in: 'Property of this Irrigation Zone',
          out: 'Irrigation zone(s) in this property',
        },
        edgeAttributes: {},
      },
    },
    IrrigationSequentialSchedule: {
      propertyHasIrrigationSequentialSchedule: {
        cardinality: undefined,
        edgeTypeId: 'propertyHasIrrigationSequentialSchedule',
        labels: {
          in: 'Property with this squential programme',
          out: 'Sequential programms made for this property',
        },
        edgeAttributes: {},
      },
    },
    IrrigationValveSchedule: {
      propertyHasIrrigationValveSchedule: {
        cardinality: undefined,
        edgeTypeId: 'propertyHasIrrigationValveSchedule',
        labels: {
          in: 'Property with this squential programme',
          out: 'Valve programms made for this property',
        },
        edgeAttributes: {},
      },
    },
    IrrigationRollingSchedule: {
      propertyHasIrrigationRollingSchedule: {
        cardinality: undefined,
        edgeTypeId: 'propertyHasIrrigationRollingSchedule',
        labels: {
          in: 'Property with this Rolling programme',
          out: 'Rolling programms made for this property',
        },
        edgeAttributes: {},
      },
    },
    Irrigator: {
      propertyHasIrrigator: {
        cardinality: undefined,
        edgeTypeId: 'propertyHasIrrigator',
        labels: {
          in: 'Property has Irrigator',
          out: 'Irrigator is for Property',
        },
        edgeAttributes: {},
      },
    },
    EffluentPath: {
      propertyHasEffluentPath: {
        cardinality: undefined,
        edgeTypeId: 'propertyHasEffluentPath',
        labels: {
          in: 'Property with this effluent path',
          out: 'Effluent path in this property',
        },
        edgeAttributes: {},
      },
    },
    // EntityRollingProgramme: {
    //   propertyHasEntityRollingProgramme: {
    //     cardinality: undefined,
    //     edgeTypeId: 'rolling_programme_schedules_group',
    //     labels: {
    //       in: 'Property with this Rolling programme',
    //       out: 'Rolling programms made for this property',
    //     },
    //     edgeAttributes: {},
    //   },
    // },
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'EntityRollingProgramme'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'Dam'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'EffluentPond'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'EffluentSump'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'EffluentTank'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'FlowMeter'),

    // ...getParentToChildEdgeTypeMatrixEntry('Property', 'Irrigator'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'EffluentSpreader'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'LateralEffluentSpreader'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'PivotEffluentSpreader'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'Pump'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'SoilMoisture'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'Tank'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'TravellingEffluentSpreader'),
    // ...getParentToChildEdgeTypeMatrixEntry('Property', 'EffluentTracker'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'SpreadingEvent'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'SpreadingGun'),
    // ...getParentToChildEdgeTypeMatrixEntry('Property', 'Paddock'),
    // ...getParentToChildEdgeTypeMatrixEntry('Property', 'Pond'),
    // ...getParentToChildEdgeTypeMatrixEntry('Property', 'Trough'),
    // ...getParentToChildEdgeTypeMatrixEntry('Property', 'WaterPump'),
    ...getParentToChildEdgeTypeMatrixEntry('Property', 'SoilMoistureArea'),

    // ...getPropertyToEntityEdgeTypeMatrixEntry('Dam'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('EffluentPond'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('EffluentSump'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('EffluentTank'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('FlowMeter'),
    // // irrigator
    // ...getPropertyToEntityEdgeTypeMatrixEntry('LateralEffluentSpreader'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('PivotEffluentSpreader'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('Pump'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('SoilMoisture'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('Tank'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('TravellingEffluentSpreader'),

    // ...getPropertyToEntityEdgeTypeMatrixEntry('EffluentTracker'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('SpreadingEvent'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('SpreadingGun'),
    // ...getPropertyToEntityEdgeTypeMatrixEntry('SoilMoistureArea'),
  },
  Group: {
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'Dam'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'EffluentPond'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'EffluentSump'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'EffluentTank'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'FlowMeter'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'Irrigator'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'EffluentSpreader'),

    ...getParentToChildEdgeTypeMatrixEntry('Group', 'LateralEffluentSpreader'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'PivotEffluentSpreader'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'Pump'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'SoilMoisture'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'Tank'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'TravellingEffluentSpreader'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'EffluentTracker'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'SpreadingEvent'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'SpreadingGun'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'Paddock'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'Pond'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'Trough'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'WaterPump'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'SoilMoistureArea'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'MasterValve'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'SVCx'),
  },
  Area: {
    ...getParentToChildEdgeTypeMatrixEntry('Area', 'Irrigator'),
    ...getParentToChildEdgeTypeMatrixEntry('Area', 'SoilMoisture'),
    ...getParentToChildEdgeTypeMatrixEntry('Area', 'MasterValve'),
    ...getParentToChildEdgeTypeMatrixEntry('Area', 'AssetTracker'),
    ...getParentToChildEdgeTypeMatrixEntry('Group', 'SVCx'),

    //     ...getAreaToEntityMatrixEntry('Irrigator'),
    // ...getAreaToEntityMatrixEntry('SoilMoisture'),
  },
  EffluentTracker: {
    DeadZone: {
      EffluentTrackerHasDeadZone: {
        cardinality: undefined,
        edgeTypeId: 'effluentTracker_has_deadZone',
        labels: {
          in: 'effluent tracker has dead zone',
          out: 'dead zone due to effluent tracker',
        },
        edgeAttributes: {},
      },
    },
  },
  LateralEffluentSpreader: {
    ...getParentToChildEdgeTypeMatrixEntry('LateralEffluentSpreader', 'DeadZone'),
    ...getParentToChildEdgeTypeMatrixEntry('LateralEffluentSpreader', 'SpreadingGun'),
    ...getParentToChildEdgeTypeMatrixEntry('LateralEffluentSpreader', 'Pump'),
    ...getParentToChildEdgeTypeMatrixEntry('LateralEffluentSpreader', 'FlowMeter'),
    ...getParentToChildEdgeTypeMatrixEntry('LateralEffluentSpreader', 'Device'),
  },
  TravellingEffluentSpreader: {
    ...getParentToChildEdgeTypeMatrixEntry('TravellingEffluentSpreader', 'DeadZone'),
    ...getParentToChildEdgeTypeMatrixEntry('TravellingEffluentSpreader', 'Pump'),
    ...getParentToChildEdgeTypeMatrixEntry('TravellingEffluentSpreader', 'FlowMeter'),
    ...getParentToChildEdgeTypeMatrixEntry('TravellingEffluentSpreader', 'Device'),
  },
  PivotEffluentSpreader: {
    ...getParentToChildEdgeTypeMatrixEntry('PivotEffluentSpreader', 'DeadZone'),
    ...getParentToChildEdgeTypeMatrixEntry('PivotEffluentSpreader', 'SpreadingGun'),
    ...getParentToChildEdgeTypeMatrixEntry('PivotEffluentSpreader', 'Pump'),
    ...getParentToChildEdgeTypeMatrixEntry('PivotEffluentSpreader', 'FlowMeter'),
    ...getParentToChildEdgeTypeMatrixEntry('PivotEffluentSpreader', 'Device'),
  },
  SpreadingGun: {
    ...getParentToChildEdgeTypeMatrixEntry('SpreadingGun', 'Pump'),
    ...getParentToChildEdgeTypeMatrixEntry('SpreadingGun', 'FlowMeter'),
  },
  IrrigationPattern: {
    IrrigatorSchedule: {
      // Pump: {
      //   PivotEffluentSpreaderHasPumpController: {
      //     cardinality: undefined,
      //     edgeTypeId: 'PivotEffluentSpreaderHasPumpController',
      //     labels: {
      //       in: 'Pivot effluent spreader has pump controller',
      //       out: 'pump controller affects pivot effluent spreader',
      //     },
      //     edgeAttributes: {},
      //   },
      // },
      irrigatorPatternHasIrrigatorSchedule: {
        cardinality: undefined,
        edgeTypeId: 'irrigatorPatternHasIrrigatorSchedule',
        labels: {
          in: 'irrigator pattern has irrigator schedule',
          out: 'irrigator schedule belongs to irrigator pattern',
        },
        edgeAttributes: {},
      },
    },
    IrrigatorSequentialProgramme: {
      irrigatorPatternHasIrrigatorSequentialProgrammee: {
        cardinality: undefined,
        edgeTypeId: 'irrigatorPatternHasIrrigatorSequentialProgrammee',
        labels: {
          in: 'irrigator pattern has irrigator sequential programme',
          out: 'irrigator sequential programme belongs to irrigator pattern',
        },
        edgeAttributes: {},
      },
    },
    Irrigator: {
      IrrigationPatternAppliedToIrrigator: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationPatternAppliedToIrrigator',
        labels: {
          in: 'irrigator pattern applied to irrigator',
          out: 'irrigator has irrigator pattern applied',
        },
        edgeAttributes: {},
      },
    },
  },
  IrrigationZone: {
    Irrigator: {
      IrrigationZoneHasIrrigator: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationZoneHasIrrigator',
        labels: {
          in: 'Irrigator(s) in this irrigator zone',
          out: 'Irrigator belongs to this irrigator zone',
        },
        edgeAttributes: {},
      },
    },
    //TODO? well there isn't technically an edge between zones and programmes, but there is a psuedo-edge, this should be cleaned up.
    IrrigationPattern: {
      IrrigationZoneHasIrrigationPattern: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationZoneHasIrrigationPattern',
        labels: {
          in: 'irrigator zone has irrigation pattern',
          out: 'irrigation pattern applies to irrigator zone',
        },
        edgeAttributes: {},
      },
    },
  },
  IrrigationSequentialSchedule: {
    IrrigatorSeqProgrammeHistory: {
      IrrigationSequentialScheduleHasIrrigatorSeqProgrammeHistory: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationSequentialScheduleHasIrrigatorSeqProgrammeHistory',
        labels: {
          in: 'irrigator sequential programme has history',
          out: 'history applies to irrigator sequential programme',
        },
        edgeAttributes: {},
      },
    },
    IrrigationPattern: {
      IrrigationSequentialProgrammeHasIrrigationPattern: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationSequentialProgrammeHasIrrigationPattern',
        labels: {
          in: 'irrigator sequential programme has irrigation patttern',
          out: 'irrigation patttern applies to irrigator sequential programme',
        },
        edgeAttributes: {},
      },
    },
    Irrigator: {
      IrrigationSequentialProgrammeAppliedToIrrigator: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationSequentialProgrammeAppliedToIrrigator',
        labels: {
          in: 'irrigator sequential programme applied to irrigator',
          out: 'irrigator has irrigator sequential programme applied',
        },
        edgeAttributes: {},
      },
    },
    IrrigationZone: {
      IrrigationSequentialScheduleUsesIrrigationZone: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationSequentialScheduleUsesIrrigationZone',
        labels: {
          in: 'Irrigator sequential programme useing this irrigation zone',
          out: 'Irrigation zones using this programme',
        },
        edgeAttributes: {},
      },
    },
  },
  IrrigationRollingSchedule: {
    IrrigatorRollingProgrammeHistory: {
      IrrigationRollingScheduleHasIrrigatorSeqProgrammeHistory: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationRollingScheduleHasIrrigatorSeqProgrammeHistory',
        labels: {
          in: 'irrigator Rolling programme has history',
          out: 'history applies to irrigator Rolling programme',
        },
        edgeAttributes: {},
      },
    },
    IrrigationPattern: {
      IrrigationRollingProgrammeHasIrrigationPattern: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationRollingProgrammeHasIrrigationPattern',
        labels: {
          in: 'irrigator Rolling programme has irrigation patttern',
          out: 'irrigation patttern applies to irrigator Rolling programme',
        },
        edgeAttributes: {},
      },
    },
    Irrigator: {
      IrrigationRollingProgrammeAppliedToIrrigator: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationRollingProgrammeAppliedToIrrigator',
        labels: {
          in: 'irrigator Rolling programme applied to irrigator',
          out: 'irrigator has irrigator Rolling programme applied',
        },
        edgeAttributes: {},
      },
    },
    IrrigationZone: {
      IrrigationRollingScheduleUsesIrrigationZone: {
        cardinality: undefined,
        edgeTypeId: 'IrrigationRollingScheduleUsesIrrigationZone',
        labels: {
          in: 'Irrigator Rolling programme useing this irrigation zone',
          out: 'Irrigation zones using this programme',
        },
        edgeAttributes: {},
      },
    },
  },
  Irrigator: {
    Device: {
      IrrigatorHasDevice: {
        cardinality: undefined,
        edgeTypeId: 'IrrigatorHasDevice',
        labels: {
          in: 'Irrigator linked to this device',
          out: 'Device EUI attached to this irrigator',
        },
        edgeAttributes: {},
      },
    },
  },
  Device: {
    IrrigationDeviceConfig: {
      IrrigatorDeviceHasIrrigationDeviceConfig: {
        cardinality: undefined,
        edgeTypeId: 'DeviceHasConfig',
        labels: {
          in: 'Device with this configuration',
          out: 'configuration of this device',
        },
        edgeAttributes: {},
      },
    },
  },
  Paddock: {
    Irrigator: {
      PaddockHasIrrigator: {
        cardinality: undefined,
        edgeTypeId: 'PaddockHasIrrigator',
        labels: {
          in: 'Irrigator is a part of this paddock',
          out: 'Paddock has irrigator(s)',
        },
        edgeAttributes: {},
      },
    },
  },
  FlowMeter: {
    ...getParentToChildEdgeTypeMatrixEntry('FlowMeter', 'Device'),
  },
  Tank: {
    ...getParentToChildEdgeTypeMatrixEntry('Tank', 'Device'),
  },
  Dam: {
    ...getParentToChildEdgeTypeMatrixEntry('Dam', 'Device'),
  },
  AssetTracker: {
    ...getParentToChildEdgeTypeMatrixEntry('AssetTracker', 'Device'),
  },

  EffluentPond: {
    ...getParentToChildEdgeTypeMatrixEntry('EffluentPond', 'Device'),
  },
  EffluentSump: {
    ...getParentToChildEdgeTypeMatrixEntry('EffluentSump', 'Device'),
  },
  Pump: {
    ...getParentToChildEdgeTypeMatrixEntry('Pump', 'Device'),
  },
  SoilMoisture: {
    ...getParentToChildEdgeTypeMatrixEntry('SoilMoisture', 'Device'),
  },
  SVCx: {
    ...getParentToChildEdgeTypeMatrixEntry('SoilMoisture', 'SVCx'),
  },
}

export const typedEdgeTypeMatrix: EdgeTypeMatrixType = edgeTypeMatrix
